module.exports = __webpack_public_path__ + "img/feature-theme.78014d0a.svg";